import {Component} from '@angular/core';
import {NavController, ViewController} from 'ionic-angular';
import {GVLogger} from "../../services/gv-logger";


/*
 Generated class for the LoginPage page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-coming-soon',
  templateUrl: 'coming-soon.html'
})
export class ComingSoon {
  // all attributes
  public attr = {
    category: 1,
    sleeve: '',
    fabric: ''
  }

  constructor(public nav: NavController, public viewCtrl: ViewController,
              private gVLogger: GVLogger) {
  }

  // close modal
  closeModal() {
    this.nav.pop();
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/coming-soon/coming-soon.ts